export default __webpack_public_path__ + "static/avatar-mp-kayi-female-0-v3-65bd600d078976c85258e4d298564ac6.png";